import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
  faArrowCircleRight,
  faArrowCircleUp,
  faArrowsAltH,
  faArrowsRotate,
  faArrowUpRightFromSquare,
  faBan,
  faBars,
  faBell,
  faBook,
  faBookmark,
  faBoxArchive,
  faBoxOpen,
  faCalendar,
  faCalendarDays,
  faCaretDown,
  faCaretUp,
  faChartGantt,
  faChartLine,
  faChartPie,
  faChartSimple,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleArrowLeft,
  faCircleArrowRight,
  faCircleExclamation,
  faCircleInfo,
  faCirclePlus,
  faCircleQuestion,
  faClock,
  faClone,
  faClose,
  faCodeCompare,
  faCoins,
  faComputer,
  faCopy,
  faDashboard,
  faDisplay,
  faDownload,
  faEllipsisVertical,
  faEnvelope,
  faEnvelopeOpenText,
  faEnvelopesBulk,
  faEraser,
  faExclamationCircle,
  faExpand,
  faExpandArrowsAlt,
  faEye,
  faEyeSlash,
  faFileExport,
  faFileImport,
  faFilePdf,
  faFilter,
  faFlagCheckered,
  faFolder,
  faGlobe,
  faGripVertical,
  faGroupArrowsRotate,
  faHeadset,
  faHome,
  faHouse,
  faIdCard,
  faKey,
  faLandmarkDome,
  faLayerGroup,
  faListCheck,
  faLocationDot,
  faLock,
  faLockOpen,
  faMagnifyingGlass,
  faMinus,
  faPenToSquare,
  faPeopleGroup,
  faPersonCircleQuestion,
  faPersonRunning,
  faPhone,
  faPlus,
  faPowerOff,
  faReceipt,
  faRectangleList,
  faRecycle,
  faRepeat,
  faReply,
  faRotate,
  faRotateLeft,
  faSave,
  faScaleUnbalanced,
  faScrewdriverWrench,
  faShareNodes,
  faSort,
  faSortDown,
  faSortUp,
  faSquareCaretRight,
  faSquareShareNodes,
  faTable,
  faTableCells,
  faThumbTack,
  faToolbox,
  faTrash,
  faTriangleExclamation,
  faTruckFast,
  faUpload,
  faUpRightFromSquare,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserGroup,
  faUsers,
  faUserTag,
  faUserTie,
  faWrench,
} from '@fortawesome/free-solid-svg-icons';

import { registerIcons as addIconsToLibrary } from '@hsp/react-component-library';

export const registerIcons = () => {
  addIconsToLibrary(
    faAngleDoubleLeft,
    faAngleDoubleRight,
    faAngleLeft,
    faAngleRight,
    faArrowCircleRight,
    faArrowCircleUp,
    faArrowsAltH,
    faArrowsRotate,
    faArrowUpRightFromSquare,
    faBan,
    faBars,
    faBell,
    faBook,
    faBookmark,
    faBoxArchive,
    faBoxOpen,
    faCalendar,
    faCalendarDays,
    faCaretDown,
    faCaretUp,
    faChartGantt,
    faChartLine,
    faChartPie,
    faChartSimple,
    faCheck,
    faCheckCircle,
    faChevronDown,
    faChevronLeft,
    faChevronRight,
    faChevronUp,
    faCircle,
    faCircleArrowLeft,
    faCircleArrowRight,
    faCircleInfo,
    faCircleExclamation,
    faCirclePlus,
    faCircleQuestion,
    faClock,
    faClone,
    faClose,
    faCodeCompare,
    faComputer,
    faCoins,
    faCopy,
    faDashboard,
    faDisplay,
    faDownload,
    faEllipsisVertical,
    faEnvelope,
    faEnvelopeOpenText,
    faEnvelopesBulk,
    faEraser,
    faExclamationCircle,
    faExpand,
    faExpandArrowsAlt,
    faEye,
    faEyeSlash,
    faFileExport,
    faFileImport,
    faFilePdf,
    faFilter,
    faFlagCheckered,
    faFolder,
    faGlobe,
    faGripVertical,
    faGroupArrowsRotate,
    faHeadset,
    faHome,
    faHouse,
    faIdCard,
    faKey,
    faLandmarkDome,
    faLayerGroup,
    faListCheck,
    faLocationDot,
    faLock,
    faLockOpen,
    faMagnifyingGlass,
    faMinus,
    faPenToSquare,
    faPeopleGroup,
    faPersonCircleQuestion,
    faPersonRunning,
    faPhone,
    faPlus,
    faPowerOff,
    faReceipt,
    faRectangleList,
    faRecycle,
    faRepeat,
    faReply,
    faRotate,
    faRotateLeft,
    faSave,
    faScaleUnbalanced,
    faScrewdriverWrench,
    faShareNodes,
    faSort,
    faSortDown,
    faSortUp,
    faSquareCaretRight,
    faSquareShareNodes,
    faTable,
    faTableCells,
    faThumbTack,
    faToolbox,
    faTrash,
    faTriangleExclamation,
    faTruckFast,
    faUpload,
    faUpRightFromSquare,
    faUser,
    faUserCheck,
    faUserCircle,
    faUserGroup,
    faUsers,
    faUserTag,
    faUserTie,
    faWrench
  );
};
